import { useSelector } from 'react-redux';

import { isDiscountMortgageBannerEnabled } from '../../selectors/discountMortgage';
import { DiscountMortgageBannerContainer } from '../DiscountMortgageBannerContainer';
import { BrokerConsultantBannerContainer } from '../BrokerConsultantBannerContainer';
import { CompareBannerContainer } from '../CompareBannerContainer';
import { selectRotatingBanner } from '../../selectors/selectRotatingBanner';

export const BannerContainer = () => {
  const isDiscountMortgageBannerAvailable = useSelector(isDiscountMortgageBannerEnabled);
  const rotatingBanner = useSelector(selectRotatingBanner);

  if (isDiscountMortgageBannerAvailable) {
    return <DiscountMortgageBannerContainer />;
  }

  if (rotatingBanner === 'broker') {
    return <BrokerConsultantBannerContainer />;
  }

  if (rotatingBanner === 'compare') {
    return <CompareBannerContainer />;
  }

  return null;
};
